import { Paperclip } from "@phosphor-icons/react";

/**
 * AttachmentBadge — visual cue that a note carries source-material files.
 *
 * Renders inline next to a note's title/eyebrow across list surfaces
 * (Notes workspace, engagement Notes tab, client Notes tab). Deliberately
 * quiet — a paperclip + count only, so partners spot substantive notes
 * without the list turning into a wall of chrome. Renders nothing when
 * the note has no attachments so callers can drop it in unconditionally.
 */
export default function AttachmentBadge({ note, className = "" }) {
  const count = note?.attachments?.length || 0;
  if (!count) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[0.625rem] font-mono uppercase tracking-widest text-primary/80 ${className}`}
      title={`${count} source ${count === 1 ? "file" : "files"} attached`}
      data-testid={`attachment-badge-${note.id}`}
    >
      <Paperclip size={11} weight="bold" />
      {count}
    </span>
  );
}
